import type { Logger } from 'pino';

import { Logger as ClientLogger } from './client-logger.ts';

let loggerInternal: Logger;

/*
 * When the code runs on the server we use the backend log infrastructure for logging.
 * Because we need to conditionally import the logger we fall back to require statements
 * since otherwise dynamic imports would lead to each log statement to be asynchronous.
 */
if (typeof window === 'undefined') {
	// Import node:module only when actually needed (server-side)
	const nodeModule = await import('node:module');
	const require = nodeModule.default.createRequire(import.meta.url);

	loggerInternal = require('./server-logger.ts').logger;
} else {
	loggerInternal = ClientLogger;
}

export const logger = loggerInternal;
